import { useQuery } from "@tanstack/react-query";
import axios from "../../../Axios";
import { Urls } from "../../../Urls";

const useFetchLRDetails = ({
  indent_id,
  indent_sub_id,
  lr_ids,
  prefetchedDetails = null,
}) => {
  const {
    data: details = {},
    isLoading: loading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["fetchLRDetails", indent_id, indent_sub_id, lr_ids],
    queryFn: async () => {
      if (prefetchedDetails) return prefetchedDetails;

      const url = `${Urls.invoice}?field=fetch_lr&indent_id=${indent_id}&indent_id_sub=${indent_sub_id}`;
      const payload = { lr_ids };

      const res = await axios.post(url, payload);
      return res?.data?.[0] || {};
    },
    enabled: !prefetchedDetails && !!indent_id,
    initialData: prefetchedDetails || undefined,
    staleTime: prefetchedDetails ? Infinity : 0,
  });

  return { details, loading, error, refetch };
};

export default useFetchLRDetails;
